import { Col, DatePicker, Modal, Row, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
// @ts-ignore
import classes from "./ActionItemsModal.module.scss";
// @ts-ignore
import AppInput from "../../components/AppInput";

import { ReactComponent as CalanderIcon } from "assets/svg/calander.svg";
import { ReactComponent as ArrowDown } from "assets/svg/arrowDownGray.svg";
// @ts-ignore
import Button from "../Button";
import { Select } from "antd";
import moment from "moment";
// @ts-ignore
import { durationList } from "../../utils/constants";
import { ReactComponent as CompleteIcon } from "assets/svg/completeCircle.svg";
import { ReactComponent as InProgressIcon } from "assets/svg/inProgressCircle.svg";
import { ReactComponent as OnHoldIcon } from "assets/svg/onHoldOrange.svg";
import { ReactComponent as CancelIcon } from "assets/svg/cancelCircle.svg";
import { ReactComponent as TodoIcon } from "assets/svg/todoCircle.svg";
import { ReactComponent as TrashRedIcon } from "assets/svg/trash-red.svg";

import { useDispatch, useSelector } from "react-redux";
import {
  getProjectUsers,
  getProjectList
// @ts-ignore
} from "../../modules/actions/UserActions";
import InviteUserModal from "../../scenes/PlanDetails/ActionItems/InviteUserModal";
// @ts-ignore
import { createNewActionItemsModal } from "../../modules/actions/PlanActions";
import { LoadingOutlined } from "@ant-design/icons";
import { closeableToast, errorToast, successToast } from "../../utils/toast";
import ActionItemComment from "./ActionItemComment";
import { actionItemWeightOptions } from "../../scenes/ProjectPlanner/components/GoalSettings/data";
import SelectMetric from "../../scenes/PlanDetails/ActionItems/Category/SelectMetric";
// @ts-ignore
import ManageCustomMetricsModal from "../../scenes/PlanDetails/Modal/ManageCustomMetrics";
import ErrorTooltip from "../ErrorTooltip";
import DeleteModal from "../DeleteModal";
import {
  deleteActionItem,
  // @ts-ignore
} from "modules/actions/PlanActions";
import { truncateName } from "../../utils/helper";

interface ActionItemsModalProps {
  isActionItem?: boolean;
  actionItemsModal: boolean;
  setActionItemsModal: (value: boolean) => void;
  data: any;
  isName?: string;
  projectPlanId: any;
  PlanDetails: any;
  allData: any;
  isOnwer?: any;
  isButtonDisabled?: boolean;
  setIsButtonDisabled?: (value: boolean) => void;
  isTask?: boolean;
}
interface InitialValues {
  ActionItemName: string;
  context: string;
  start_line: string | null;
  dead_line: string | null;
  weight: number | null;
  start: any | null;
  current: any | null;
  target: any | null;
  duration: number | null;
  plan_progress: number | null;
  Priority: number | null;
  category: string | null;
  Status: number | null;
  Assignee: string | null;
  project_plan_name: string | null;
  category_name: string | null;
  project_plan_id: string | null;
}
export const ActionItemsModal: React.FC<ActionItemsModalProps> = ({
  isActionItem,
  actionItemsModal,
  setActionItemsModal,
  data,
  projectPlanId,
  allData,
  isOnwer,
  isButtonDisabled,
  setIsButtonDisabled,
  isTask = false,
}) => {
  const dispatch = useDispatch();

  const { Option } = Select;
  const { projectUser, projectList } = useSelector(
    (state: any) => state.user.projectOwners
  );
  const [isLoading, setIsLoading] = useState(false);
  const initialValues = {
    ActionItemName: allData?.name,
    context: "",
    start_line: allData?.start_line,
    dead_line: allData?.dead_line,
    weight: allData?.weight,
    start: allData?.start,
    current: allData?.current,
    target: allData?.target,
    duration: allData?.duration,
    plan_progress: allData?.plan_progress,
    Priority: allData?.priority,
    category: allData?.category,
    Status: allData?.status,
    Assignee: allData?.responsible_person?.email,
    project_plan_name: allData?.project_plan_name,
    category_name: allData?.category_name,
    project_plan_id: allData?.project_plan_id,
    description: allData?.description,
  };

  const { planDetails } = useSelector(
    (state: { plan: any }) => state.plan.plan
  );

  const [values, setValues] = useState<InitialValues>(initialValues);
  const [hasChanged, setHasChanged] = useState(false);
  const [note, setNote] = useState<string | null>(null);
  const [assigneeID, setAssigneeId] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [showInvite, setShowInvite] = useState<boolean>(false);
  const [emailToInvite, setEmailToInvite] = useState<string | null>(null);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [deleteItemName, setDeleteItemName] = useState<string | null>(null);
  const [deleteItemLoading, setDeleteItemLoading] = useState<boolean>(false);
  const [category, setCategory] = useState<any[]>([]);
  const [selectedValue, setSelectedValue] = useState<{
    label: string;
    unit: string;
    unitId: string;
    isCustom?: boolean;
  }>({
    label: "",
    unit: "",
    unitId: "",
    isCustom: false,
  });

  const [selectedUnit, setSelectedUnit] = useState<string | null>();
  const [modalOpen, setModalOpen] = useState(false);
  const [IsAddMetric, setIsAddMetric] = useState(false);

  useEffect(() => {
    const isChanged = Object.keys(initialValues).some(
      (key) =>
        values[key as keyof InitialValues] !==
        initialValues[key as keyof InitialValues]
    );
    setHasChanged(isChanged);
    const isActionItemNameEmpty = values.ActionItemName.trim().length === 0;
    if (isActionItemNameEmpty) {
      setHasChanged(!isActionItemNameEmpty);
    } else {
      setHasChanged(isChanged);
    }
  }, [values]);

  useEffect(() => {
    dispatch(getProjectUsers());
    dispatch(getProjectList());
  }, [dispatch]);

  useEffect(() => {
    setNote(allData?.description);
    getUnit(allData?.label);
  }, [allData]);

  useEffect(() => {
    const project = projectList?.filter(
      (item: any) => item.id == allData?.project_plan_id
    );
    if (project) {
      setCategory(project[0]?.action_categories);
    }
  }, [projectList]);

  const selectedUser = projectUser.find((user: any) => user?.id === assigneeID);

  const momentDeadLine = values?.dead_line
    ? moment(values?.dead_line, "YYYY-MM-DD").format("YYYY-MM-DD")
    : null;

  const momentStartLine = values?.start_line
    ? moment(values?.start_line, "YYYY-MM-DD").format("YYYY-MM-DD")
    : null;

  const AssignOptions = projectUser?.map((user: any) => ({
    label: user.email,
    value: user.id,
    image: user?.profile_picture,
    initials: user.name
      ? user.name.match(/\b\w/g)?.join("")
      : user.email[0].toUpperCase(),
  }));

  const handleSearch = (value: string) => {
    setSearchTerm(value);
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    const userExists = AssignOptions.some(
      (option: any) => option.label && option.label.includes(value)
    );
    setShowInvite(isEmailValid && !userExists);
  };

  function getUnit(label: string) {
    switch (label) {
      case "custom":
        setSelectedUnit(allData?.custom_unit_name);
        break;
      default:
        setSelectedUnit(allData?.metric_unit_name);
    }
  }

  const handleInviteClick = () => {
    setIsModalVisible(true);
    setEmailToInvite(searchTerm);
  };

  const closeModal = () => {
    setIsModalVisible(false);
    setEmailToInvite(null);
    setSearchTerm("");
    setShowInvite(false);
    dispatch(getProjectUsers());
  };

  const truncateText = (text: string, maxLength: number) => {
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };

  const handleClose = () => {
    successToast("Your action was updated successfully");
    setActionItemsModal?.(false);
    setIsLoading(false);
  };

  const handleAddMetric = () => {
    setModalOpen(true);
  };

  const handleError = () => {
    setIsLoading(false);
  };

  const onSubmit = async () => {
    setIsLoading(true);

    const unitKey = selectedValue?.isCustom ? "custom_unit" : "metric_unit";

    try {
      let actionItem = {
        id: allData.id,
        name: values.ActionItemName,
        weight: values.weight,
        start: values.start ? Number(values.start).toFixed(2) : null,
        current: values.current ? Number(values.current).toFixed(2) : null,
        target: values.target ? Number(values.target).toFixed(2) : null,
        start_line: momentStartLine,
        dead_line: momentDeadLine,
        duration: values?.duration,
        responsible_person: assigneeID || allData?.responsible_person?.id || "",
        status: values?.Status,
        plan_progress: values?.plan_progress,
        priority: values?.Priority,
        project_plan: Number(values?.project_plan_id),
        category: values?.category,
        description: note,
        [unitKey]: selectedValue?.unitId,
      };

      if (selectedValue?.isCustom) {
        actionItem = {
          ...actionItem,
          label: "custom",
        };
      } else {
        actionItem = {
          ...actionItem,
          label: "",
        };
      }

      const notePayload = {
        action_item: allData?.id,
      };

      const payload = { action_item: actionItem, note: notePayload };
      const plan_id = projectPlanId || values?.project_plan_id;

      await dispatch(
        createNewActionItemsModal(
          payload,
          plan_id,
          false,
          handleClose,
          isTask ? true : false,
          handleError
        )
      );
    } catch (error) {
      errorToast("Failed to update action item. Please try again.");
      setIsLoading(false);
    }
  };

  const handleDelete = () => {
    setDeleteItemLoading(true);
    dispatch(
      deleteActionItem(
        allData?.id,
        projectPlanId,
        () => {
          setDeleteItemLoading(false);
          setOpenDeleteModal(false);
          setActionItemsModal(false);
          setIsButtonDisabled?.(false);
          closeableToast(
            `You have successfully deleted ${truncateName(allData?.name)}`,
            `${isTask ? "Task" : "Action Item"} Deleted successfully`,
            "delete"
          );
        },
        isTask,
        () => {
          setDeleteItemLoading(false);
          setOpenDeleteModal(false);
          setActionItemsModal(false);
          setIsButtonDisabled?.(false);
        }
      )
    );
  };

  const updateActionStatus = (value: number) => {
    let updatedStatus: any = values.Status;
    if (value === 10) {
      updatedStatus = 4;
    } else if (value === 0) {
      updatedStatus = 1;
    } else {
      updatedStatus = 2;
    }

    setValues({
      ...values,
      plan_progress: value,
      Status: updatedStatus,
    });
  };

  const updateProgress = (value: number) => {
    let updatedPlanProgress = values.plan_progress;
    if (value === 4) {
      updatedPlanProgress = 10;
    } else if (value === 1) {
      updatedPlanProgress = 0;
    } else if (
      value === 2 &&
      (updatedPlanProgress === 0 ||
        updatedPlanProgress === 10 ||
        updatedPlanProgress === null)
    ) {
      updatedPlanProgress = 5;
    }
    setValues({
      ...values,
      Status: value,
      plan_progress: updatedPlanProgress,
    });
  };

  const isUnitUnchanged =
    selectedValue !== undefined
      ? allData?.label === "custom"
        ? selectedValue?.unitId === allData?.custom_unit
        : selectedValue?.unitId === allData?.metric_unit
      : true;

  useEffect(() => {
    if (
      actionItemsModal &&
      (allData?.metric_unit_name || allData?.custom_unit_name)
    ) {
      const customLabel = allData?.label === "custom";

      const findCustomLabel =
        planDetails?.goal?.custom_labels?.length > 0 &&
        planDetails?.goal?.custom_labels
          ?.map((label: any) => {
            const customUnit = label?.custom_unit_options?.find(
              (option: any) => option.id === allData?.custom_unit
            );

            if (customUnit) {
              return {
                label: customUnit?.value,
                customUnit: customUnit?.id,
              };
            }
            return null;
          })
          ?.filter(Boolean);

      setSelectedUnit(
        customLabel ? findCustomLabel?.[0]?.label : allData?.metric_unit_name
      );

      setSelectedValue({
        label: customLabel
          ? findCustomLabel?.[0]?.label
          : allData?.metric_unit_name,
        unit: customLabel
          ? findCustomLabel?.[0]?.customUnit
          : allData?.metric_unit,
        unitId: customLabel
          ? findCustomLabel?.[0]?.customUnit
          : allData?.metric_unit,
        isCustom: customLabel ? true : false,
      });
    }
  }, [
    actionItemsModal,
    allData?.metric_unit_name,
    allData?.custom_unit_name,
    planDetails,
  ]);

  return (
    <>
      <ManageCustomMetricsModal
        IsAddMetric={IsAddMetric}
        setIsAddMetric={setIsAddMetric}
        visible={modalOpen}
        setModalOpen={setModalOpen}
        goalId={planDetails?.goal?.id}
        project_plan={projectPlanId}
      />

      <DeleteModal
        openDeleteModal={openDeleteModal}
        onCloseDeleteModal={() => setOpenDeleteModal(false)}
        isLoading={deleteItemLoading}
        onDelete={handleDelete}
        title={isTask ? "Delete Task" : "Delete Action Item"}
        description={`Are you sure you want to delete “${deleteItemName}” from your ${
          isTask ? "task list" : "action item list"
        }. 
        This ${isTask ? "task" : "action item"} cannot be reversed `}
      />

      <Modal
        centered
        open={actionItemsModal}
        closable={false}
        style={{
          margin: "10px 0px",
        }}
        bodyStyle={{
          padding: "10px",
          backgroundColor: "#FAFAFA",
        }}
        width={1053}
        footer={
          <div className={classes.modalFooter}>
            <Button
              style={{
                backgroundColor: "transparent",
                borderRadius: "2px",
                color: "#FF0000",
                border: "1px solid #FF0000",
                width: "88px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                textTransform: "capitalize",
              }}
              onClick={() => {
                setDeleteItemName(allData?.name);
                setOpenDeleteModal(true);
              }}
              disabled={isLoading}
            >
              <TrashRedIcon />
              Delete
            </Button>

            <div className={classes.modalFooterActions}>
              <Button
                style={{
                  backgroundColor: "transparent",
                  borderRadius: "2px",
                  color: "#1271A6",
                  border: "1px solid #1271A6",
                  width: "88px",
                }}
                onClick={() => {
                  setActionItemsModal(false);
                  setIsButtonDisabled?.(false);
                }}
                disabled={isLoading}
              >
                Cancel
              </Button>

              {isButtonDisabled && (
                <ErrorTooltip
                  title={
                    "Cannot update Action Item under an inactive category."
                  }
                  isActionItem={true}
                />
              )}

              <Button
                onClick={onSubmit}
                disabled={
                  isButtonDisabled
                    ? true
                    : !isUnitUnchanged
                    ? false
                    : !hasChanged || isLoading
                }
                style={{
                  position: "relative",
                  backgroundColor: "#1271A6",
                  color: "white",
                  width: "88px",
                  border: "1px solid #1271A6",
                  borderRadius: "2px",
                  opacity: isButtonDisabled
                    ? 0.5
                    : !isUnitUnchanged
                    ? 1
                    : !hasChanged
                    ? 0.5
                    : 1,
                }}
              >
                {isLoading ? <LoadingOutlined /> : "Save"}
              </Button>
            </div>
          </div>
        }
      >
        <div className={classes.wrapperModal}>
          <div className={classes.header}>
            <span>Action Item Details</span>
            <button
              type="button"
              onClick={() => {
                setActionItemsModal(false);
                setIsButtonDisabled?.(false);
              }}
              className={classes.close}
              title="Close"
            >
              X
            </button>
          </div>
          <Row style={{ height: "100%" }}>
            <Col md={16} className={classes.LeftSide}>
              <div className={classes.inputBox}>
                <label className={classes.label}>Action Item Name</label>
                <AppInput
                  type="text"
                  className="input"
                  placeholder="Action Item Name"
                  value={values?.ActionItemName}
                  onChange={(name: string, value: string) => {
                    setValues({ ...values, ActionItemName: value });
                  }}
                  error={values?.ActionItemName?.length == 0 ? true : false}

                  // value={allData?.name}
                  // onChange={handleActionItemChange}
                />

                {values?.ActionItemName?.trim()?.length == 0 && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    This field may not be blank
                  </div>
                )}
              </div>

              <div className={classes.inputBox}>
                <label className={classes.label} htmlFor="">
                  Description
                </label>

                <textarea
                  placeholder="Add a description"
                  value={note || ""}
                  onChange={(e) => {
                    let value = e.target.value;

                    if (value?.startsWith(" ")) {
                      value = value.trim();
                    }

                    setNote(value);
                    setHasChanged(true);
                  }}
                ></textarea>
              </div>

              <Row gutter={16} className={classes.row}>
                <Col md={8}>
                  <label className={classes.label} htmlFor="">
                    Status
                  </label>

                  <Select
                    dropdownMatchSelectWidth={false}
                    size="large"
                    placeholder="Status"
                    className={classes.styleLine}
                    suffixIcon={<ArrowDown />}
                    value={values.Status}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    onChange={(value: any) => {
                      updateProgress(value);
                    }}
                  >
                    <Select.Option value="" disabled>
                      Select
                    </Select.Option>
                    <Select.Option value={1}>
                      <TodoIcon style={{ marginRight: 8 }} />
                      To Do
                    </Select.Option>
                    <Select.Option value={2}>
                      <InProgressIcon style={{ marginRight: 8 }} />
                      In Progress
                    </Select.Option>
                    <Select.Option value={3}>
                      <OnHoldIcon style={{ marginRight: 8 }} />
                      On Hold
                    </Select.Option>
                    <Select.Option value={4}>
                      <CompleteIcon style={{ marginRight: 8 }} />
                      Completed
                    </Select.Option>
                    <Select.Option value={5}>
                      <CancelIcon style={{ marginRight: 8 }} />
                      Canceled
                    </Select.Option>
                  </Select>
                </Col>

                <Col md={8}>
                  <div className={classes.box}>
                    <label className={classes.label} htmlFor="">
                      Start Date
                    </label>
                    <DatePicker
                      size="large"
                      allowClear
                      placeholder="MM/DD/YYYY"
                      className={`antd-suffixIcon ${classes.styleLine}`}
                      inputReadOnly={true}
                      disabled={!isOnwer}
                      suffixIcon={<CalanderIcon />}
                      getPopupContainer={(triggerNode) =>
                        triggerNode.parentNode as HTMLElement
                      }
                      style={{
                        width: "100%",
                        border: "1px solid #E5E5E5",
                        borderRadius: "4px",
                        fontSize: "14px",
                      }}
                      value={
                        values?.start_line ? moment(values?.start_line) : null
                      }
                      disabledDate={(current) => {
                        const startLine = allData?.category_details?.start_line
                          ? moment(
                              allData?.category_details.start_line
                            ).startOf("day")
                          : null;
                        const deadLine = allData?.category_details?.dead_line
                          ? moment(allData?.category_details?.dead_line).endOf(
                              "day"
                            )
                          : null;

                        return (
                          current &&
                          ((startLine && current.isBefore(startLine)) ||
                            (deadLine && current.isAfter(deadLine)) ||
                            current.isAfter(values?.dead_line))
                        );
                      }}
                      onChange={(date, value) => {
                        setValues({
                          ...values,
                          start_line: date
                            ? moment(date).format("YYYY-MM-DD")
                            : null,
                        });
                      }}
                    />
                  </div>
                </Col>
                <Col md={8}>
                  <div className={classes.box}>
                    <label className={classes.label} htmlFor="">
                      Due Date
                    </label>
                    <DatePicker
                      size="large"
                      allowClear
                      placeholder="MM/DD/YYYY"
                      className={`antd-suffixIcon ${classes.styleLine}`}
                      getPopupContainer={(triggerNode) =>
                        triggerNode.parentNode as HTMLElement
                      }
                      inputReadOnly={true}
                      suffixIcon={<CalanderIcon />}
                      disabled={!isOnwer}
                      style={{
                        width: "100%",
                        border: "1px solid #E5E5E5",
                        borderRadius: "4px",
                        fontSize: "14px",
                      }}
                      value={
                        values?.dead_line ? moment(values?.dead_line) : null
                      }
                      disabledDate={(current) => {
                        const startLine = allData?.category_details?.start_line
                          ? moment(allData.category_details.start_line).startOf(
                              "day"
                            )
                          : null;
                        const deadLine = allData?.category_details?.dead_line
                          ? moment(allData?.category_details.dead_line).endOf(
                              "day"
                            )
                          : null;
                        return (
                          current &&
                          ((startLine && current.isBefore(startLine)) ||
                            (deadLine && current.isAfter(deadLine)) ||
                            current.isBefore(values?.start_line))
                        );
                      }}
                      onChange={(date, value) => {
                        setValues({
                          ...values,
                          dead_line: date
                            ? moment(date).format("YYYY-MM-DD")
                            : null,
                        });
                      }}
                    />
                  </div>
                </Col>
              </Row>

              <div className={classes.measurementBox}>
                <h3 className={classes.measurementTitle}>Measurement</h3>

                <Row className={classes.measurementContainer}>
                  <div className={classes.box}>
                    <label className={classes.label} htmlFor="">
                      Metric{" "}
                    </label>

                    <SelectMetric
                      onAddMetric={handleAddMetric}
                      selectedValue={selectedValue}
                      setSelectedValue={setSelectedValue}
                      selectedUnit={selectedUnit}
                      setSelectedUnit={setSelectedUnit}
                      setIsAddMetric={setIsAddMetric}
                      isFullWidth={true}
                    />
                  </div>

                  <div className={classes.box}>
                    <label className={classes.label} htmlFor="">
                      Start Value
                    </label>
                    <AppInput
                      type="number"
                      className="input"
                      placeholder="Start"
                      value={values.start}
                      borderRadius="4px"
                      borderColor="#e5e5e5"
                      notPadding={true}
                      onChange={(name: string, value: string) => {
                        setValues({ ...values, start: value });
                      }}
                    />
                  </div>

                  <div className={classes.box}>
                    <label className={classes.label} htmlFor="">
                      Current Value
                    </label>
                    <AppInput
                      type="number"
                      className="input"
                      placeholder="Current"
                      value={values.current}
                      borderRadius="4px"
                      borderColor="#e5e5e5"
                      notPadding={true}
                      onChange={(name: string, value: string) => {
                        setValues({ ...values, current: value });
                      }}
                    />
                  </div>

                  <div className={classes.box}>
                    <label className={classes.label} htmlFor="">
                      Target Value
                    </label>
                    <AppInput
                      type="number"
                      className="input"
                      placeholder="Target"
                      value={values.target}
                      borderRadius="4px"
                      borderColor="#e5e5e5"
                      notPadding={true}
                      onChange={(name: string, value: string) => {
                        setValues({ ...values, target: value });
                      }}
                    />
                  </div>
                </Row>
              </div>

              <Row gutter={16} className={classes.row}>
                <Col md={8}>
                  <label className={classes.label} htmlFor="">
                    Weight
                  </label>
                  <Select
                    dropdownMatchSelectWidth={false}
                    size="large"
                    placeholder="Weight"
                    className={classes.styleLine}
                    suffixIcon={<ArrowDown />}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    value={values?.weight}
                    onChange={(value) => {
                      setValues({ ...values, weight: value });
                    }}
                  >
                    {actionItemWeightOptions.map((count: any, index: any) => (
                      <Option key={index} value={count.value}>
                        {count.key}
                      </Option>
                    ))}
                  </Select>
                </Col>

                <Col md={8}>
                  <div className={classes.box}>
                    <label className={classes.label} htmlFor="">
                      Priority
                    </label>

                    <Select
                      dropdownMatchSelectWidth={false}
                      size="large"
                      placeholder="Priority"
                      className={classes.styleLine}
                      getPopupContainer={(triggerNode) =>
                        triggerNode.parentNode
                      }
                      suffixIcon={<ArrowDown />}
                      value={values?.Priority}
                      onChange={(value) => {
                        setValues({ ...values, Priority: value });
                      }}
                    >
                      {[
                        { value: 3, label: "High" },
                        { value: 2, label: "Medium" },
                        { value: 1, label: "Low" },
                      ].map((count, index) => (
                        <Option key={index} value={count.value}>
                          {count.label}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </Col>

                <Col md={8}>
                  <div className={classes.box}>
                    <label
                      className={classes.label}
                      htmlFor=""
                      style={{ backgroundColor: "#fffff" }}
                    >
                      Plan Progress
                    </label>

                    <Select
                      dropdownMatchSelectWidth={false}
                      size="large"
                      placeholder="Plan Progress"
                      className={classes.styleLine}
                      getPopupContainer={(triggerNode) =>
                        triggerNode.parentNode
                      }
                      suffixIcon={<ArrowDown />}
                      value={values.plan_progress}
                      onChange={(value: number) => {
                        updateActionStatus(value);
                      }}
                    >
                      {actionItemWeightOptions.map((count, index) => (
                        <Option key={index} value={count.value}>
                          {count.label}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </Col>
              </Row>

              <Row gutter={16} className={classes.row}>
                <Col md={16}>
                  <div className={classes.box}>
                    <label className={classes.label} htmlFor="">
                      Assigned To
                    </label>
                    <Select
                      size="large"
                      placeholder="--"
                      className={classes.styleLine}
                      getPopupContainer={(triggerNode) =>
                        triggerNode.parentNode
                      }
                      value={
                        selectedUser
                          ? {
                              key: selectedUser,
                              label: (
                                <Tooltip
                                  title={selectedUser.email}
                                  placement="top"
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {selectedUser?.profile_picture ? (
                                      <img
                                        src={selectedUser?.profile_picture}
                                        style={{
                                          minWidth: 24,
                                          height: 24,
                                          borderRadius: "50%",
                                          marginRight: 8,
                                        }}
                                      />
                                    ) : (
                                      <div
                                        style={{
                                          minWidth: 24,
                                          height: 24,
                                          borderRadius: "50%",
                                          backgroundColor: "#ccc",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          marginRight: 8,
                                        }}
                                      >
                                        {selectedUser?.email[0]}
                                      </div>
                                    )}
                                    <span>
                                      {(() => {
                                        const text = truncateText(
                                          selectedUser?.username ||
                                            selectedUser?.first_name ||
                                            selectedUser?.last_name ||
                                            selectedUser?.email?.split(
                                              "@"
                                            )[0] ||
                                            "",
                                          40
                                        );

                                        const words = text.split(" ");
                                        return words.length > 20
                                          ? `${words.slice(0, 8).join(" ")}...`
                                          : text;
                                      })()}
                                    </span>
                                  </div>
                                </Tooltip>
                              ),
                            }
                          : {
                              label: values?.Assignee ? (
                                <Tooltip
                                  title={values.Assignee}
                                  placement="top"
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        minWidth: 24,
                                        height: 24,
                                        borderRadius: "50%",
                                        backgroundColor: "#ccc",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginRight: 8,
                                      }}
                                    >
                                      {values?.Assignee[0]}
                                    </div>
                                    <span>
                                      {values?.Assignee?.split("@")[0]}
                                    </span>
                                  </div>
                                </Tooltip>
                              ) : (
                                "--"
                              ),
                            }
                      }
                      showSearch
                      filterOption={(input: any, option: any) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                      onSearch={handleSearch}
                      labelInValue
                      onSelect={(value: any) => {
                        setAssigneeId(value?.value);
                        setValues({ ...values, Assignee: value });
                      }}
                      notFoundContent={
                        showInvite && (
                          <Button
                            type="primary"
                            onClick={handleInviteClick}
                            style={{ width: "100%" }}
                          >
                            Invite {searchTerm}
                          </Button>
                        )
                      }
                      optionLabelProp="label"
                    >
                      {AssignOptions.map((option: any, index: any) => (
                        <Select.Option
                          key={index}
                          value={option.value}
                          label={option.label}
                        >
                          <Tooltip title={option.label} placement="top">
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {option.image ? (
                                <img
                                  src={option.image}
                                  alt={option.label}
                                  style={{
                                    width: 24,
                                    height: 24,
                                    borderRadius: "50%",
                                    marginRight: 8,
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    minWidth: 24,
                                    height: 24,
                                    borderRadius: "50%",
                                    backgroundColor: "#ccc",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginRight: 8,
                                  }}
                                >
                                  {option.label ? option.label[0] : "-"}
                                </div>
                              )}
                              <span> {truncateText(option.label, 50)}</span>
                            </div>
                          </Tooltip>
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                </Col>

                <Col md={8}>
                  <div className={classes.box}>
                    <label className={classes.label} htmlFor="">
                      Estimated Duration
                    </label>
                    <Select
                      dropdownMatchSelectWidth={false}
                      size="large"
                      placeholder="-- --"
                      getPopupContainer={(triggerNode) =>
                        triggerNode.parentNode
                      }
                      className={classes.styleLine}
                      suffixIcon={<ArrowDown />}
                      value={values.duration}
                      onChange={(value) => {
                        setValues({ ...values, duration: value });
                      }}
                    >
                      {durationList.map((count: any, index: any) => (
                        <Option key={index} value={count.value}>
                          {count.key}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </Col>
              </Row>

              <div className={classes.inputBox}>
                <label className={classes.label}>Project</label>
                <Select
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  dropdownStyle={{
                    width: 300, // Set your custom width here
                  }}
                  dropdownMatchSelectWidth={false}
                  size="large"
                  placeholder="Plan Projects"
                  style={{
                    width: "100%",
                    border: "1px solid #E5E5E5",
                    maxWidth: "100%",
                  }}
                  suffixIcon={<ArrowDown />}
                  value={values?.project_plan_name}
                  onChange={(value: any) => {
                    const project = projectList?.find(
                      (item: any) => item.id == value
                    );
                    if (project) {
                      setCategory(project?.action_categories);
                    }
                    setValues({
                      ...values,
                      project_plan_name: project?.name,
                      project_plan_id: value,
                      category_name: project?.action_categories[0]?.name,
                      category: project?.action_categories[0]?.id,
                    });
                  }}
                  showSearch
                  filterOption={(input, option: any) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {projectList.map((p?: any) => (
                    <Option key={String(p.id)} value={String(p.id)}>
                      {p.name}
                    </Option>
                  ))}
                </Select>
              </div>

              <div className={classes.inputBox}>
                <label className={classes.label}>Category</label>
                <Select
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  dropdownStyle={{
                    width: 300, // Set your custom width here
                  }}
                  dropdownMatchSelectWidth={false}
                  size="large"
                  placeholder="Category"
                  disabled={allData?.project_plan_name === 0}
                  style={{
                    width: "100%",
                    border: "1px solid #E5E5E5",
                  }}
                  suffixIcon={<ArrowDown />}
                  value={values?.category_name}
                  onChange={(value) => {
                    const filterCategory = category?.find(
                      (item) => item.id === value
                    );
                    if (filterCategory) {
                      setValues({
                        ...values,
                        category_name: filterCategory.name,
                        category: value,
                      });
                    }
                  }}
                  showSearch
                  filterOption={(input: string, option: any) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {category?.map((c: any, index: any) => (
                    <Option key={index} value={c.id}>
                      {c.name}
                    </Option>
                  ))}
                </Select>
              </div>
            </Col>
            <Col md={8} className={classes.RightSide}>
              <ActionItemComment actionItemId={allData?.id} />
            </Col>
          </Row>
        </div>
      </Modal>
      {isModalVisible && (
        <InviteUserModal
          isActive={isModalVisible}
          emailToInvite={emailToInvite ?? ""}
          onClose={closeModal}
        />
      )}
    </>
  );
};
